import { postOrderStatus } from '../../services/api/order.api';
import { POST_ORDER_STATUS_REQUEST, POST_ORDER_STATUS_SUCCESS, POST_ORDER_STATUS_FAILURE } from '../types';
import { transformOrderDetail } from '../../transforms/order';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[POST_ORDER_STATUS_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[POST_ORDER_STATUS_SUCCESS](state) {
			state.isLoading = false;
		},
		[POST_ORDER_STATUS_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async updateOrderStatus({ commit }, id) {
			try {
				commit(POST_ORDER_STATUS_REQUEST);
				const { data } = await postOrderStatus(id);

				this.dispatch('orderSingle/updateState', {
					data: transformOrderDetail(data),
				});

				commit(POST_ORDER_STATUS_SUCCESS);
			} catch (error) {
				commit(POST_ORDER_STATUS_FAILURE, error);
			}
		},
	},
};